import { useEffect, useState } from "react";
import Collapsible from "../../../components/panels/collapsible";
import SelectField from "../../../components/Input/select-field";
import { useTemplateTrackTypesQuery } from "../../../services/enumApi";
import './track-type-filter.scss';

export default function TrackTypeFilter({ 
    trackTypeCategories,
    checkedTrackTypes,
    setCheckedTrackTypes,
    selectedTemplateTrackType,
    setSelectedTemplateTrackType,
    allowedTrackCategories,
    checkedImageTypes,
    setCheckedImageTypes,
    checkedLithologyTypes,
    setCheckedLithologyTypes,
    checkedStratigraphyTypes,
    setCheckedStratigraphyTypes,
    checkedTextTypes,
    setCheckedTextTypes,
    imageTypes
} : any) {    

    const [selectedTrackCategory, setSelectedTrackCategory] = useState<any>(null);
    const [trackTypes, setTrackTypes] = useState<any[]>([]);

    const { data: templateTrackTypes, isLoading: templateTrackTypesLoading } = useTemplateTrackTypesQuery(allowedTrackCategories);

    const trackCategories = trackTypeCategories?.filter((c: any) => !c.hidden);
    const filteredTrackCategories = trackCategories?.filter((t: any) => 
        t.trackTypes.filter((trackType: any) => 
            trackType.allowedTrackTypes.some((t: any) => t == selectedTemplateTrackType)
        ).length > 0
    );

    const lithologyTrackTypeCategory = trackTypeCategories?.find((trackCategory: any) => trackCategory.id == "1033");
    const lithologyTrackTypes = lithologyTrackTypeCategory?.trackTypes;

    const stratigraphyTrackTypeCategory = trackTypeCategories?.find((trackCategory: any) => trackCategory.id == "1040");
    const stratigraphyTrackTypes = stratigraphyTrackTypeCategory?.trackTypes;

    const textTrackTypeCategory = trackTypeCategories?.find((trackCategory: any) => trackCategory.id == "1038");
    const textTrackTypes = textTrackTypeCategory?.trackTypes;

    useEffect(() => {
        if (filteredTrackCategories?.length) {
            setSelectedTrackCategory(filteredTrackCategories[0]);
        }
    }, [filteredTrackCategories?.length, selectedTemplateTrackType]);

    useEffect(() => {
        if (selectedTrackCategory?.trackTypes) {
            setTrackTypes(selectedTrackCategory.trackTypes.filter((trackType: any) => 
                trackType.allowedTrackTypes.some((t: any) => t == selectedTemplateTrackType)
            ));
        }
    }, [selectedTrackCategory?.id, selectedTemplateTrackType]);

    const onChangeTrackTypeList = (e: any) => {            
        const value = +e.target.value;
        if (checkedTrackTypes.includes(value)) {
            const newTrackTypes = [...checkedTrackTypes].filter((id) => id !== value);
            setCheckedTrackTypes(newTrackTypes);
        } else {
            const newTrackTypes = [...checkedTrackTypes];
            newTrackTypes.push(value);
            setCheckedTrackTypes(newTrackTypes);
        }
    };

    const onChangeImageTypeList = (e: any) => {            
        const value = +e.target.value;
        if (checkedImageTypes.includes(value)) {
            const newImageTypes = [...checkedImageTypes].filter((id: number) => id !== value);
            setCheckedImageTypes(newImageTypes);
        } else {
            const newImageTypes = [...checkedImageTypes];
            newImageTypes.push(value);
            setCheckedImageTypes(newImageTypes);
        }
    };

    const onChangeLithologyTypeList = (e: any) => {            
        const value = +e.target.value;
        if (checkedLithologyTypes.includes(value)) {
            const newLithologyTypes = [...checkedLithologyTypes].filter((id: number) => id !== value);
            setCheckedLithologyTypes(newLithologyTypes);
        } else {
            const newLithologyTypes = [...checkedLithologyTypes];
            newLithologyTypes.push(value);
            setCheckedLithologyTypes(newLithologyTypes);
        }
    };

    const onChangeStratigraphyTypeList = (e: any) => {
        const value = +e.target.value;  
        if (checkedStratigraphyTypes.includes(value)) {
            const newStratigraphyTypes = [...checkedStratigraphyTypes].filter((id: number) => id !== value);
            setCheckedStratigraphyTypes(newStratigraphyTypes);
        } else {
            const newStratigraphyTypes = [...checkedStratigraphyTypes];
            newStratigraphyTypes.push(value);
            setCheckedStratigraphyTypes(newStratigraphyTypes);
        }
    };

    const onChangeTextTypeList = (e: any) => {      
        const value = +e.target.value;
        if (checkedTextTypes.includes(value)) {
            const newTextTypes = [...checkedTextTypes].filter((id: number) => id !== value);
            setCheckedTextTypes(newTextTypes);
        } else {
            const newTextTypes = [...checkedTextTypes];
            newTextTypes.push(value);
            setCheckedTextTypes(newTextTypes);
        }
    };

    const onChangeTrackType = (value: any) => {      
        setSelectedTemplateTrackType(+value);
        setCheckedTrackTypes([]);
        setCheckedImageTypes([]);
        setCheckedLithologyTypes([]);
        setCheckedStratigraphyTypes([]);
        setCheckedTextTypes([]);
    };

    const onChangeTrackCategory = (e: any) => {
        const trackTypeCategory = filteredTrackCategories.find((trackCategory: any) => trackCategory.id == e.target.value);
        setSelectedTrackCategory(trackTypeCategory);
    };

    const onReset = () => {
        setCheckedTrackTypes([]);
        setCheckedImageTypes([]);
        setCheckedLithologyTypes([]);
        setCheckedStratigraphyTypes([]);
        setCheckedTextTypes([]);
        if (filteredTrackCategories?.length) {
            setSelectedTrackCategory(filteredTrackCategories[0]);
        }
    };

    const isSelected = checkedTrackTypes?.length > 0 || checkedImageTypes?.length > 0 || checkedLithologyTypes?.length > 0 || checkedStratigraphyTypes?.length > 0 || checkedTextTypes?.length > 0;

    return (
        <Collapsible label="Track Type" isSelected={isSelected} showReset={isSelected} reset={onReset}>
            <div className="track-type-filter">
                <SelectField   
                    label="Track Type" 
                    values={templateTrackTypes?.filter((t: any) => allowedTrackCategories.includes(t.value))} 
                    onChange={onChangeTrackType} 
                    value={selectedTemplateTrackType} />

                {(selectedTemplateTrackType === 0 || selectedTemplateTrackType === 3 || selectedTemplateTrackType === 4 || selectedTemplateTrackType == 8) && (
                    <>
                        <div className="field">        
                            <label className="label">Track Category</label>
                            <div className="control">
                                <div className="select">
                                    <select onChange={onChangeTrackCategory} value={selectedTrackCategory?.id}>
                                        {(filteredTrackCategories || []).map((trackCategory: any, index: number) => (
                                            <option key={index} value={trackCategory.id}>{trackCategory.name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="field">        
                            <label className="label">Specific Track Types</label>
                            <div className="control">
                                <div className="track-type-list">
                                    {(trackTypes || []).map((trackType: any, index: number) => (
                                        <div key={index}>
                                            <label>
                                                <input 
                                                    type="checkbox" 
                                                    value={trackType.id} 
                                                    onChange={(e) => onChangeTrackTypeList(e)} 
                                                    checked={checkedTrackTypes.includes(trackType.id)}
                                                />
                                                &nbsp;{trackType.name}                                                
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {selectedTemplateTrackType === 1 && (
                    <>
                        <div className="field">        
                            <label className="label">Image Types</label>
                            <div className="control">
                                <div className="track-type-list">
                                    {(imageTypes || []).map((imageType: any, index: number) => (
                                        <div key={index}>
                                            <label>
                                                <input 
                                                    type="checkbox" 
                                                    value={imageType.value} 
                                                    onChange={(e) => onChangeImageTypeList(e)} 
                                                    checked={checkedImageTypes.includes(imageType.value)}
                                                />
                                                &nbsp;{imageType.name}                                              
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {selectedTemplateTrackType === 5 && (
                    <>
                        <div className="field">        
                            <label className="label">Lithology Types</label>
                            <div className="control">
                                <div className="track-type-list">
                                    {(lithologyTrackTypes || []).map((lithologyTrackType: any, index: number) => (
                                        <div key={index}>
                                            <label>
                                                <input 
                                                    type="checkbox" 
                                                    value={+lithologyTrackType.id} 
                                                    onChange={(e) => onChangeLithologyTypeList(e)} 
                                                    checked={checkedLithologyTypes.includes(+lithologyTrackType.id)}
                                                />
                                                &nbsp;{lithologyTrackType.name}                                               
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {selectedTemplateTrackType === 7 && (
                    <>
                        <div className="field">        
                            <label className="label">Text Types</label>
                            <div className="control">
                                <div className="track-type-list">
                                    {(textTrackTypes || []).map((trackType: any, index: number) => (
                                        <div key={index}>
                                            <label>
                                                <input 
                                                    type="checkbox" 
                                                    value={trackType.id} 
                                                    onChange={onChangeTextTypeList} 
                                                    checked={checkedTextTypes.includes(trackType.id)}
                                                />
                                                &nbsp;{trackType.name}                                             
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {selectedTemplateTrackType === 9 && (
                    <>
                        <div className="field">        
                            <label className="label">Stratigraphy Types</label>
                            <div className="control">
                                <div className="track-type-list">
                                    {(stratigraphyTrackTypes || []).map((stratigraphyTrackType: any, index: number) => (
                                        <div key={index}>
                                            <label>
                                                <input 
                                                    type="checkbox" 
                                                    value={+stratigraphyTrackType.id} 
                                                    onChange={(e) => onChangeStratigraphyTypeList(e)} 
                                                    checked={checkedStratigraphyTypes.includes(+stratigraphyTrackType.id)}
                                                />
                                                &nbsp;{stratigraphyTrackType.name}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </Collapsible>
    );
}
